import './maryluna-product.js';

let dialog;
let controller;

function getDialog(trigger) {
  if (dialog) return dialog;
  dialog = document.createElement('dialog');
  dialog.className = 'ml-qv-dialog';
  dialog.tabIndex = -1;
  dialog.innerHTML = `<button type="button" class="ml-qv-dialog__close" aria-label="${trigger.dataset.closeLabel}"><img src="${new URL('icon-maryluna-close.svg', import.meta.url)}" alt="" width="20" height="20"></button><div class="ml-qv-dialog__content"></div>`;
  dialog.querySelector('.ml-qv-dialog__close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    controller?.abort();
    if (!document.querySelector('dialog:modal')) document.documentElement.removeAttribute('scroll-lock');
  });
  document.addEventListener('maryluna:cart:added', () => dialog.open && dialog.close());
  document.body.append(dialog);
  return dialog;
}

function loadStyles(link) {
  if (!link || document.querySelector(`link[href="${link.getAttribute('href')}"]`)) return;
  return new Promise((resolve) => {
    const stylesheet = link.cloneNode();
    stylesheet.addEventListener('load', resolve, { once: true });
    stylesheet.addEventListener('error', resolve, { once: true });
    document.head.append(stylesheet);
  });
}

async function open(trigger) {
  const modal = getDialog(trigger);
  const content = modal.querySelector('.ml-qv-dialog__content');
  controller?.abort();
  controller = new AbortController();
  const url = new URL(trigger.href);
  url.searchParams.set('section_id', 'maryluna-quick-view');
  content.setAttribute('aria-busy', 'true');
  modal.setAttribute('aria-label', trigger.getAttribute('aria-label'));
  const response = await fetch(url, { signal: controller.signal });
  if (!response.ok) throw new Error(response.statusText);
  const html = new DOMParser().parseFromString(await response.text(), 'text/html');
  const view = html.querySelector('.ml-qv');
  if (!view) throw new Error('Missing quick view');
  await loadStyles(html.querySelector('link[rel="stylesheet"]'));
  content.replaceChildren(view);
  content.removeAttribute('aria-busy');
  if (!modal.open) {
    modal.showModal();
    modal.focus();
    document.documentElement.setAttribute('scroll-lock', '');
  }
}

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element && event.target.closest('a[data-quick-view]');
  if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey) return;
  event.preventDefault();
  open(trigger).catch((error) => {
    if (error.name !== 'AbortError') window.location.assign(trigger.href);
  });
});
